import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {DeleteSetInput, WorkoutRepository} from '../ports/workout.repository';

export class DeleteSet implements UseCase<[DeleteSetInput], Workout> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: DeleteSetInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.deleteSet(input);
  }
}
